// Border-radius scale — consistent rounding across components
// Current codebase mixes "8px" (inputs/buttons), "15px" (sidebar), "20px" (cards).
// This scale normalises those as named tokens.

export const radiiFoundation = {
  radii: {
    none: '0',
    sm: '4px', // tags, micro elements
    md: '6px', // inputs, selects, small buttons
    lg: '8px', // buttons, badges, dropdowns
    xl: '12px', // panels, tooltips, popovers
    '2xl': '16px', // modals
    '3xl': '20px', // cards (matches Card.js baseStyle)
    full: '9999px', // pills, avatars
  },
};
